import React, { useState, useMemo, useContext, useEffect, useRef } from 'react'
import { WorkspaceContext } from '../WorkspaceContext';
import './newpop.scss'
// import './newpop.scss';
import { useParams } from 'react-router-dom';
import api from '../../../api';
import { codeSuggestions, resolveSnippetFromTypedName } from './AcceptedLanguages';
import useCloseOnClickAway from '../../../shared/hooks/UseCloseOnClickAway';
import { useDriveView } from '../DriveViewContext';
import { isNameTakenInDirectory, NAME_TAKEN_MESSAGE } from '../../../shared/utils/nameCollision';
import { getSnippetIcon } from '../../../shared/utils/getFileIconAndExtensionHelper';








const NewSnipPop = () => {


    const ctx = useContext(WorkspaceContext);
    if (!ctx) throw new Error("Workspace must be wrapped in WorkspaceContext.Provider");
    const { globalNewSnipPopup, setGlobalNewSnipPopup, setPendingOpenId, Folders, Snippets, Files, uiMode } = ctx;
    const { folderId: driveFolderId } = useDriveView();
    const targetFolderParent = uiMode === 'files' ? driveFolderId : null;


    const yourClientId = localStorage.getItem('flashroom_id');


    const popupRef = useRef<HTMLDivElement | null>(null);
    useCloseOnClickAway({
        targetRef: popupRef,
        onClose: () => setGlobalNewSnipPopup(false)
    })




    const [snippetNameVal, setSnippetNameVal] = useState('');
    const [nsPerm, setNsPerm] = useState('view');
    const [isCreating, setIsCreating] = useState(false);
    const creatingRef = useRef(false);
    const [submitError, setSubmitError] = useState<string | null>(null);

    const [manualFileType, setManualFileType] = useState('');



    const nsPermClick = (perm: string) => {
        // setActiveNsPerm(perm);
        setNsPerm(perm);
    }

    const inputRef = useRef<HTMLInputElement | null>(null);




    const { roomId } = useParams();
    const trimmedName = snippetNameVal.trim();

    const typedDot = trimmedName.lastIndexOf('.');
    const typedExt = typedDot > 0 ? trimmedName.slice(typedDot).toLowerCase().trim() : '';

    // Live duplicate-name feedback, same as the editor sidebar's inline
    // creation — only once a "name.ext"-shaped suffix exists (no point
    // comparing before there's anything to compare), independent of whether
    // that extension is actually a *valid* one.
    const nameConflict = typedDot > 0 && isNameTakenInDirectory({
        folderParent: targetFolderParent,
        effectiveName: trimmedName,
        folders: Folders,
        snippets: Snippets,
        files: Files,
    });

    const issueMessage = nameConflict ? NAME_TAKEN_MESSAGE : submitError ?? '';

    // Live type-icon preview — mirrors the same name/extension resolution
    // used on submit, so the icon shown here always matches what the file
    // would actually be created as (VS Code shows this same live preview
    // while typing a new file name).
    const previewIcon = useMemo(() => {
        const resolved = resolveSnippetFromTypedName(snippetNameVal, manualFileType);
        if (!resolved.ok) return null;
        return getSnippetIcon(resolved.snippetType === 'code' ? (resolved.snippetLanguage ?? 'txt') : 'txt');
    }, [snippetNameVal, manualFileType]);


    const nsCancelClick = () => {
        setGlobalNewSnipPopup(false);
        setSnippetNameVal('');
        setManualFileType('');
        setSubmitError(null);
    }

    const fileTypeTabClick = (ftype: string) => {
        setManualFileType(ftype);

        if (snippetNameVal.trim() === '') {
            const nextValue = `Untitled${ftype}`;
            setSnippetNameVal(nextValue);

            requestAnimationFrame(() => {
                if (inputRef.current) {
                    inputRef.current.focus();
                    inputRef.current.setSelectionRange(0, 'Untitled'.length);
                }
            });

            return;
        }

        const trimmed = snippetNameVal.trim();
        const lastDot = trimmed.lastIndexOf('.');

        if (lastDot > 0) {
            const nameOnly = trimmed.slice(0, lastDot).trim();
            setSnippetNameVal(`${nameOnly}${ftype}`);
        } else {
            setSnippetNameVal(`${trimmed}${ftype}`);
        }
    };

    useEffect(() => {
        if (typedExt) {
            setManualFileType(typedExt);
        }
    }, [typedExt]);

    const createSnippetClick = async () => {
        if (creatingRef.current) return;

        try {
            creatingRef.current = true;
            setIsCreating(true);
            const trimmed = snippetNameVal.trim();
            if (!trimmed) {
                setSubmitError('File name required');
                return;
            }

            const resolved = resolveSnippetFromTypedName(trimmed, manualFileType);
            if (!resolved.ok) {
                setSubmitError(
                    resolved.reason === 'language' ? 'Choose a valid language' : 'Use format: name.extension'
                );
                return;
            }

            if (nameConflict) {
                setSubmitError(NAME_TAKEN_MESSAGE);
                return;
            }

            const payload = {
                snippetName: resolved.baseName,
                snippetType: resolved.snippetType,
                snipText: '',
                snippetLanguage: resolved.snippetLanguage,
                snipPermissions: nsPerm,
                createdBy: yourClientId,
                snippetSetting: 'room',
                folderParent: uiMode === 'files' ? driveFolderId : null,
            };

            const res = await api.post(`/rooms/${roomId}/snippets`, payload);
            nsCancelClick();

            const newId = await res.data.snippet._id;
            setPendingOpenId(newId);
        } catch (error: any) {
            const message = error?.response?.data?.error || error?.response?.data?.message || 'Could not create file. Please try again.';
            setSubmitError(message);
        } finally {
            creatingRef.current = false;
            setIsCreating(false);
        }
    };





    const canSubmit = useMemo(() => {
        if (!globalNewSnipPopup || isCreating) return false;
        if (nameConflict) return false;
        return true;
    }, [globalNewSnipPopup, isCreating, nameConflict]);

    const handleSnippetKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key !== 'Enter' || !canSubmit) return;

        e.preventDefault();
        void createSnippetClick();
    };








    return (
        <div ref={popupRef} className='new-snip fade-in'>
            <div className='relative'>


                <div className='ns-top'>
                    <h3>New File</h3>

                    <button className='ns-cancel' onClick={nsCancelClick}>
                        <svg className="x-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                            <g id="Layer_3" data-name="Layer 3">
                                <path
                                    className="cls-1"
                                    d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                    transform="translate(-124.17 -181.62)"
                                />
                            </g>
                        </svg>
                    </button>


                </div>




                <div className='ns-input-wrap'>
                    {previewIcon && (
                        <img draggable={false} className='ns-input-icon' src={`${process.env.PUBLIC_URL}/images/${previewIcon}.png`} alt="" />
                    )}

                    <input
                        type='text'
                        ref={inputRef}
                        className={previewIcon ? 'ns-input-has-icon' : ''}
                        placeholder='file name: ex: index.html'
                        maxLength={20}
                        value={snippetNameVal}
                        onKeyDown={handleSnippetKeyDown}
                        onChange={(e) => {
                            setSnippetNameVal(e.target.value);
                            if (submitError) setSubmitError(null);
                        }}
                    />
                </div>
                {issueMessage ? (
                    <span className='issue'>{issueMessage}</span>
                ) : (
                    <span className='incl'>Include File extension or select below</span>
                )}


                {/* <div className='fil-type-msg-o'>
                <span className='fil-type-msg'>include file extension, or select manually</span>
            </div> */}
                <div className='manual-file-type-select-area'>
                    <div className='mftsa-txt'>
                        <div
                            className={`mtfsa-card ${manualFileType === '.txt' ? 'active-mtfsa' : ''}`}
                            onClick={() => fileTypeTabClick('.txt')}
                        >
                            <div className='mtfsa-c-img'>
                                <img draggable={false} src={`${process.env.PUBLIC_URL}/images/text.png`} />
                            </div>
                            <div style={{ height: '2px' }} />
                            <h6>.txt</h6>
                        </div>


                        {/* <div className='mtfsa-card'
                            onClick={() => manualFileSelectClick('.docx')}
                        >
                            <div className='mtfsa-c-img'>
                                <img src={`${process.env.PUBLIC_URL}/images/docx.png`} />
                            </div>
                            <h6>.docx</h6>
                        </div> */}


                        {codeSuggestions.map(co => (
                            <div
                                key={co.cValue}
                                className={`mtfsa-card ${manualFileType === `${co.extension}` ? 'active-mtfsa' : ''}`}
                                onClick={() => fileTypeTabClick(co.extension)}
                            >

                                <div className='mtfsa-c-img'>
                                    <img draggable={false} src={`${process.env.PUBLIC_URL}/images/${co.imageName}.png`} />
                                </div>
                                <div style={{ height: '2px' }} />
                                <h6>{co.extension}</h6>

                            </div>
                        ))}




                    </div>

                </div>





                <div className='ns-bottom'>
                    <div style={{ marginTop: '18px' }}>

                        <select
                            className="co-select"
                            value={nsPerm}
                            onChange={(e) => nsPermClick(e.target.value)}
                        >
                            <option value='view'>
                                Read Only
                            </option>

                            <option value='edit'>
                                Open
                            </option>

                        </select>


                    </div>
                    <div className='quick-flex'>
                        <button className='ns-cancel-b' onClick={nsCancelClick}>Cancel</button>
                        <button onClick={createSnippetClick} disabled={!canSubmit} className={`ns-create ${!canSubmit ? 'ns-disabled' : ''}`}>Create</button>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default NewSnipPop
